import { render, staticRenderFns } from "./CCSwitch.vue?vue&type=template&id=6bfc3de8"
import script from "./CCSwitch.vue?vue&type=script&lang=js"
export * from "./CCSwitch.vue?vue&type=script&lang=js"
import style0 from "./CCSwitch.vue?vue&type=style&index=0&id=6bfc3de8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports